import React, { useContext } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import graphql from 'babel-plugin-relay/macro';
import QueryRender from 'components/QueryRender';
import SessionContext from 'context/SessionContext';
import { useHistory } from 'react-router-dom';
import RefreshCountsContext from 'context/RefreshCountsContext';
import { VIEW_CALL } from 'config/permissions';

const userCountsQuery = graphql`
  query TaskBellUserCountsQuery($userId: ID!) {
    userCounts(userId: $userId) {
      pendingTasks
      pendingTickets
      upcomingCalls
    }
  }
`;

export default function TasksTicketsBell() {
  const { user, can } = useContext(SessionContext);
  const { refreshKey, refreshCounts } = useContext(RefreshCountsContext);
  const [totalPending, setTotalPending] = React.useState(0);
  const history = useHistory();

  const variables = {
    userId: user.id,
  };

  return (
    <>
      <QueryRender
        key={refreshKey}
        query={userCountsQuery}
        variables={variables}
        render={({ props }) => {
          if (props) {
            const { userCounts } = props;
            const callsCount = can(VIEW_CALL) ? (userCounts.upcomingCalls || 0) : 0;
            const total = (userCounts.pendingTasks || 0) + (userCounts.pendingTickets || 0) + callsCount;
            setTotalPending(total);
          }
          return null;
        }}
      />

      <div onClick={() => history.push('/task')} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '1px' }}>
        <Icon name='file alternate' />
        {totalPending > 0 && (
          <Label circular color='red' size='medium' style={{ padding: '1px', margin: 0 }}>
            {totalPending}
          </Label>
        )}
      </div>
    </>
  );
}

export { RefreshCountsContext };